// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"ms-z","giftOrPromoSelector":"ns-z","disabled":"os-z","subTitle":"ps-z","selectShipAddressMessage":"qs-z","changePayment":"rs-z"};